import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import logo from '../../assets/logo-light.svg'
import { handleLogout } from "../../components/headers"
import ThemeToggle from '../../components/ThemeToggle'
import ContactEmails from './ContactEmails'
import './DashboardHeader.css'
import useIsMobile from '../../hooks/isMobile'

export default function DashboardHeader({match, emails, companyName}) {

    const navigate = useNavigate()
    const editAccount = () => navigate('/participant/account')
    const [showContact, setShowContact] = useState(false)

    const isMobile = useIsMobile()
    const [isOpen, setIsOpen] = useState(false)
    useEffect(() => { if(!isMobile) setIsOpen(false) }, [isMobile])
    const handleOpen = () => setIsOpen(!isOpen)

    return(
        <div className="w-100 gap-s wrap center wrapper" style={{padding: isMobile ? 'var(--xs) var(--s)' : 'var(--s) 36px'}}>
            {showContact && <ContactEmails emails={emails} onClose={() => setShowContact(false)}/>}
            {!isMobile && <div className=" flex gap-m center" style={{padding: 'var(--s) var(--l) var(--s) var(--s)'}}>
                <MatchDetails match={match}/>
            </div>}
            {emails?.length > 0 && !isMobile && <button className='solid-accent' onClick={() => setShowContact(true)}>Contact {companyName}</button>}
            <div className={`flex center ${isMobile ? 'w-100 space-between' : ''}`}>
                <div className='flex center'>
                    {isMobile && <button className='outline inverted icon h-spacer-s' onClick={handleOpen}><span className="material-symbols-outlined">menu</span></button>}
                    <img src={logo} className='h-spacer-l' style={{height: '44px'}}></img>
                </div>
                <div>
                    <ThemeToggle className={'outline inverted'}/>
                    {!isMobile && <button className='outline inverted icon hi-spacer-xs' onClick={editAccount}><span className="material-symbols-outlined">person</span></button>}
                    <button className='outline inverted icon h-spacer-xs hi-spacer-xs' onClick={handleLogout}><span className="material-symbols-outlined">logout</span></button>
                </div>
            </div>
            {isOpen && <div className='padding-s showing page-xs-centered w-100'>
                <div className='flex gap-m center w-100 v-spacer-m'>
                    <MatchDetails match={match}/>
                </div>
                {emails?.length > 0 && <button className='h-spacer-l solid-accent w-100 v-spacer-xs' onClick={() => setShowContact(true)}>Contact {companyName}</button>}
                <button className='outline inverted w-100' onClick={editAccount}>Account</button>
            </div>}
        </div>
    )
}

function MatchDetails({match}) {

    return(<>
        <div className="dashed-card padding-s" style={{borderRadius: '100%', border: '3px solid rgb(var(--neutral))'}}><span className="material-symbols-outlined scale-xxl neutral">{match?.type == 'Mentor' ? 'supervisor_account' : 'person'}</span></div>
        <div>
            <p className="card-body neutral medium">Your <span className="bold on-dark">{match?.type ?? 'Companion'}</span></p>
            <p className="card-label on-dark">{match?.firstName ?? 'Unknown'} {match?.lastName ?? 'Unknown'}</p>
        </div>
    </>)
}